var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled from "styled-components";
import { getColor } from "../helpers/ColorHelpers";
import IconActivities from "./icons/IconActivities";
import IconAdd from "./icons/IconAdd";
import IconAddAbove from "./icons/IconAddAbove";
import IconAddBelow from "./icons/IconAddBelow";
import IconAddCircle from "./icons/IconAddCircle";
import IconAddLeft from "./icons/IconAddLeft";
import IconAddRight from "./icons/IconAddRight";
import IconAddSquare from "./icons/IconAddSquare";
import IconAdmin from "./icons/IconAdmin";
import IconArchive from "./icons/IconArchive";
import IconArrowDown from "./icons/IconArrowDown";
import IconArrowLeft from "./icons/IconArrowLeft";
import IconArrowLeftRight from "./icons/IconArrowLeftRight";
import IconArrowRight from "./icons/IconArrowRight";
import IconArrowUp from "./icons/IconArrowUp";
import IconArrowUpDown from "./icons/IconArrowUpDown";
import IconArticleCheck from "./icons/IconArticleCheck";
import IconArticleTimes from "./icons/IconArticleTimes";
import IconAsking from "./icons/IconAsking";
import IconAsterisk from "./icons/IconAsterisk";
import IconAtSign from "./icons/IconAtSign";
import IconAudio from "./icons/IconAudio";
import IconAward from "./icons/IconAward";
import IconBell from "./icons/IconBell";
import IconBirthday from "./icons/IconBirthday";
import IconBomb from "./icons/IconBomb";
import IconBook from "./icons/IconBook";
import IconBookmark from "./icons/IconBookmark";
import IconBookmarkOutline from "./icons/IconBookmarkOutline";
import IconBox from "./icons/IconBox";
import IconBranchTopRight from "./icons/IconBranchTopRight";
import IconBulb from "./icons/IconBulb";
import IconCalendar from "./icons/IconCalendar";
import IconCamera from "./icons/IconCamera";
import IconCameraTimes from "./icons/IconCameraTimes";
import IconChartBar from "./icons/IconChartBar";
import IconChartPie from "./icons/IconChartPie";
import IconChat from "./icons/IconChat";
import IconCheck from "./icons/IconCheck";
import IconCheckboxChecked from "./icons/IconCheckboxChecked";
import IconCheckboxUnchecked from "./icons/IconCheckboxUnchecked";
import IconCheckCircle from "./icons/IconCheckCircle";
import IconCheckSquare from "./icons/IconCheckSquare";
import IconCheckThin from "./icons/IconCheckThin";
import IconCheckTimes from "./icons/IconCheckTimes";
import IconChevronDown from "./icons/IconChevronDown";
import IconChevronDownDouble from "./icons/IconChevronDownDouble";
import IconChevronLeft from "./icons/IconChevronLeft";
import IconChevronLeftDouble from "./icons/IconChevronLeftDouble";
import IconChevronLeftRight from "./icons/IconChevronLeftRight";
import IconChevronRight from "./icons/IconChevronRight";
import IconChevronRightDouble from "./icons/IconChevronRightDouble";
import IconChevronRightLeft from "./icons/IconChevronRightLeft";
import IconChevronUp from "./icons/IconChevronUp";
import IconChevronUpDouble from "./icons/IconChevronUpDouble";
import IconChevronUpDown from "./icons/IconChevronUpDown";
import IconCircle from "./icons/IconCircle";
import IconCircleDot from "./icons/IconCircleDot";
import IconClipboard from "./icons/IconClipboard";
import IconClock from "./icons/IconClock";
import IconCmsAdmin from "./icons/IconCmsAdmin";
import IconCmsSerach from "./icons/IconCmsSerach";
import IconCog from "./icons/IconCog";
import IconCogInfo from "./icons/IconCogInfo";
import IconColumn1 from "./icons/IconColumn1";
import IconColumn2 from "./icons/IconColumn2";
import IconColumn3 from "./icons/IconColumn3";
import IconColumnMinus from "./icons/IconColumnMinus";
import IconColumnPlus from "./icons/IconColumnPlus";
import IconComment from "./icons/IconComment";
import IconContentAggregation from "./icons/IconContentAggregation";
import IconCopy from "./icons/IconCopy";
import IconCopyMode from "./icons/IconCopyMode";
import IconCopyRight from "./icons/IconCopyRight";
import IconCopyTimes from "./icons/IconCopyTimes";
import IconCopyVideo from "./icons/IconCopyVideo";
import IconCrop from "./icons/IconCrop";
import IconDataPrivacy from "./icons/IconDataPrivacy";
import IconDecrease from "./icons/IconDecrease";
import IconDelete from "./icons/IconDelete";
import IconDeleteColumn from "./icons/IconDeleteColumn";
import IconDeleteEmpty from "./icons/IconDeleteEmpty";
import IconDeleteRow from "./icons/IconDeleteRow";
import IconDice from "./icons/IconDice";
import IconDownload from "./icons/IconDownload";
import IconDownloadCloud from "./icons/IconDownloadCloud";
import IconDownVote from "./icons/IconDownVote";
import IconEdit from "./icons/IconEdit";
import IconEditClose from "./icons/IconEditClose";
import IconEditorListBullet from "./icons/IconEditorListBullet";
import IconEditorListBulletTimes from "./icons/IconEditorListBulletTimes";
import IconEditorListOrdered from "./icons/IconEditorListOrdered";
import IconEditorPPElink from "./icons/IconEditorPPElink";
import IconEditorTextBackground from "./icons/IconEditorTextBackground";
import IconEditorTextBold from "./icons/IconEditorTextBold";
import IconEditorTextColor from "./icons/IconEditorTextColor";
import IconEditorTextItalic from "./icons/IconEditorTextItalic";
import IconEditorTextSize from "./icons/IconEditorTextSize";
import IconEditorUnderline from "./icons/IconEditorUnderline";
import IconEditTableBottom from "./icons/IconEditTableBottom";
import IconEditTableLeft from "./icons/IconEditTableLeft";
import IconEditTableRight from "./icons/IconEditTableRight";
import IconEditTableTop from "./icons/IconEditTableTop";
import IconEducation from "./icons/IconEducation";
import IconEmoFrown from "./icons/IconEmoFrown";
import IconEmoNeutral from "./icons/IconEmoNeutral";
import IconEmoSmile from "./icons/IconEmoSmile";
import IconEmpty from "./icons/IconEmpty";
import IconExcite from "./icons/IconExcite";
import IconExclamation from "./icons/IconExclamation";
import IconExclamationCircle from "./icons/IconExclamationCircle";
import IconExclamationTriangle from "./icons/IconExclamationTriangle";
import IconExpand from "./icons/IconExpand";
import IconExport from "./icons/IconExport";
import IconExternalLink from "./icons/IconExternalLink";
import IconEyeCheck from "./icons/IconEyeCheck";
import IconEyeClose from "./icons/IconEyeClose";
import IconEyeOpen from "./icons/IconEyeOpen";
import IconEyeTimes from "./icons/IconEyeTimes";
import IconFastBackward from "./icons/IconFastBackward";
import IconFastForward from "./icons/IconFastForward";
import IconFeed from "./icons/IconFeed";
import IconFile from "./icons/IconFile";
import IconFileReference from "./icons/IconFileReference";
import IconFilter from "./icons/IconFilter";
import IconFilterCheck from "./icons/IconFilterCheck";
import IconFilterTimes from "./icons/IconFilterTimes";
import IconFilterUndo from "./icons/IconFilterUndo";
import IconFlag from "./icons/IconFlag";
import IconFlagBack from "./icons/IconFlagBack";
import IconFolder from "./icons/IconFolder";
import IconFolderAdd from "./icons/IconFolderAdd";
import IconFolderMinus from "./icons/IconFolderMinus";
import IconFolderOpen from "./icons/IconFolderOpen";
import IconFolderUp from "./icons/IconFolderUp";
import IconForward from "./icons/IconForward";
import IconFriends from "./icons/IconFriends";
import IconGame from "./icons/IconGame";
import IconGames from "./icons/IconGames";
import IconGlobe from "./icons/IconGlobe";
import IconGraphEdge from "./icons/IconGraphEdge";
import IconGraphNode from "./icons/IconGraphNode";
import IconGrid from "./icons/IconGrid";
import IconGridH from "./icons/IconGridH";
import IconGridV from "./icons/IconGridV";
import IconHash from "./icons/IconHash";
import IconHeart from "./icons/IconHeart";
import IconHelpCircle from "./icons/IconHelpCircle";
import IconHistoryBack from "./icons/IconHistoryBack";
import IconHistoryForward from "./icons/IconHistoryForward";
import IconHome from "./icons/IconHome";
import IconHotspot from "./icons/IconHotspot";
import IconImage from "./icons/IconImage";
import IconImageEffects from "./icons/IconImageEffects";
import IconImages from "./icons/IconImages";
import IconImport from "./icons/IconImport";
import IconInfo from "./icons/IconInfo";
import IconInfoBrain from "./icons/IconInfoBrain";
import IconInfoPlus from "./icons/IconInfoPlus";
import IconKey from "./icons/IconKey";
import IconLanguage from "./icons/IconLanguage";
import IconLanguageSelect from "./icons/IconLanguageSelect";
import IconLanguageSquare from "./icons/IconLanguageSquare";
import IconLaw from "./icons/IconLaw";
import IconLink from "./icons/IconLink";
import IconLinkInternal from "./icons/IconLinkInternal";
import IconLocation from "./icons/IconLocation";
import IconLock from "./icons/IconLock";
import IconLogin from "./icons/IconLogin";
import IconLogout from "./icons/IconLogout";
import IconMail from "./icons/IconMail";
import IconMaximize from "./icons/IconMaximize";
import IconMenu from "./icons/IconMenu";
import IconMenuClose from "./icons/IconMenuClose";
import IconMerge from "./icons/IconMerge";
import IconMicOff from "./icons/IconMicOff";
import IconMicOn from "./icons/IconMicOn";
import IconMinimize from "./icons/IconMinimize";
import IconMinus from "./icons/IconMinus";
import IconMinusCircle from "./icons/IconMinusCircle";
import IconMinusSquare from "./icons/IconMinusSquare";
import IconMirrorH from "./icons/IconMirrorH";
import IconMirrorV from "./icons/IconMirrorV";
import IconMobile from "./icons/IconMobile";
import IconMonitor from "./icons/IconMonitor";
import IconMonitor4K from "./icons/IconMonitor4K";
import IconMonitorHD from "./icons/IconMonitorHD";
import IconMonitorSD from "./icons/IconMonitorSD";
import IconMonitorText from "./icons/IconMonitorText";
import IconMore from "./icons/IconMore";
import IconMoreClose from "./icons/IconMoreClose";
import IconMoreVertical from "./icons/IconMoreVertical";
import IconMusic from "./icons/IconMusic";
import IconPackage from "./icons/IconPackage";
import IconPaperclip from "./icons/IconPaperclip";
import IconPause from "./icons/IconPause";
import IconPauseCircle from "./icons/IconPauseCircle";
import IconPencil from "./icons/IconPencil";
import IconPercent from "./icons/IconPercent";
import IconPlay from "./icons/IconPlay";
import IconPlayCircle from "./icons/IconPlayCircle";
import IconPlaylist from "./icons/IconPlaylist";
import IconPlaylistEdit from "./icons/IconPlaylistEdit";
import IconPublish from "./icons/IconPublish";
import IconPublished from "./icons/IconPublished";
import IconQrCode from "./icons/IconQrCode";
import IconQrCodeTimes from "./icons/IconQrCodeTimes";
import IconQuestionmark from "./icons/IconQuestionmark";
import IconQuestionmarkCircle from "./icons/IconQuestionmarkCircle";
import IconQuote from "./icons/IconQuote";
import IconRedo from "./icons/IconRedo";
import IconReload from "./icons/IconReload";
import IconReply from "./icons/IconReply";
import IconResume from "./icons/IconResume";
import IconRocket from "./icons/IconRocket";
import IconRotateDown from "./icons/IconRotateDown";
import IconRotateLeft from "./icons/IconRotateLeft";
import IconRotateRight from "./icons/IconRotateRight";
import IconRotateUp from "./icons/IconRotateUp";
import IconSave from "./icons/IconSave";
import IconSearch from "./icons/IconSearch";
import IconSearchClose from "./icons/IconSearchClose";
import IconSelect from "./icons/IconSelect";
import IconSelectAll from "./icons/IconSelectAll";
import IconSend from "./icons/IconSend";
import IconShapes from "./icons/IconShapes";
import IconSkipBackward from "./icons/IconSkipBackward";
import IconSkipForward from "./icons/IconSkipForward";
import IconSlideshow from "./icons/IconSlideshow";
import IconSortAZ from "./icons/IconSortAZ";
import IconSortZA from "./icons/IconSortZA";
import IconStarEmpty from "./icons/IconStarEmpty";
import IconStarFull from "./icons/IconStarFull";
import IconStarHalf from "./icons/IconStarHalf";
import IconStats from "./icons/IconStats";
import IconStop from "./icons/IconStop";
import IconSubtitle from "./icons/IconSubtitle";
import IconTable from "./icons/IconTable";
import IconTableAddRow from "./icons/IconTableAddRow";
import IconTableMinusRow from "./icons/IconTableMinusRow";
import IconTablet from "./icons/IconTablet";
import IconTableview from "./icons/IconTableview";
import IconTag from "./icons/IconTag";
import IconThumbDown from "./icons/IconThumbDown";
import IconThumbnail from "./icons/IconThumbnail";
import IconThumbUp from "./icons/IconThumbUp";
import IconTimes from "./icons/IconTimes";
import IconTimesCircle from "./icons/IconTimesCircle";
import IconTimesSquare from "./icons/IconTimesSquare";
import IconTrending from "./icons/IconTrending";
import IconTurnedOff from "./icons/IconTurnedOff";
import IconTurnedOn from "./icons/IconTurnedOn";
import IconUndo from "./icons/IconUndo";
import IconUnlock from "./icons/IconUnlock";
import IconUnmerge from "./icons/IconUnmerge";
import IconUnpublish from "./icons/IconUnpublish";
import IconUnpublished from "./icons/IconUnpublished";
import IconUpload from "./icons/IconUpload";
import IconUploadAudio from "./icons/IconUploadAudio";
import IconUploadCloud from "./icons/IconUploadCloud";
import IconUploadImage from "./icons/IconUploadImage";
import IconUploadVideo from "./icons/IconUploadVideo";
import IconUpVote from "./icons/IconUpVote";
import IconUser from "./icons/IconUser";
import IconUserAdd from "./icons/IconUserAdd";
import IconUserCheck from "./icons/IconUserCheck";
import IconUserEdit from "./icons/IconUserEdit";
import IconUserLogout from "./icons/IconUserLogout";
import IconUserMinus from "./icons/IconUserMinus";
import IconUsers from "./icons/IconUsers";
import IconUserTimes from "./icons/IconUserTimes";
import IconVersion from "./icons/IconVersion";
import IconVideoPlayer from "./icons/IconVideoPlayer";
import IconVideoReference from "./icons/IconVideoReference";
import IconWiki from "./icons/IconWiki";
import IconWorkflow from "./icons/IconWorkflow";
import IconZoomIn from "./icons/IconZoomIn";
import IconZoomOut from "./icons/IconZoomOut";
import IconFeedRss from "./icons/IconFeedRss";
import IconFolderEmpty from "./icons/IconFolderEmpty";
import IconPosCC from "./icons/IconPosCC";
import IconPosTL from "./icons/IconPosTL";
import IconPosTC from "./icons/IconPosTC";
import IconPosTR from "./icons/IconPosTR";
import IconPosCL from "./icons/IconPosCL";
import IconPosCR from "./icons/IconPosCR";
import IconPosBL from "./icons/IconPosBL";
import IconPosBC from "./icons/IconPosBC";
import IconPosBR from "./icons/IconPosBR";
import IconMailOpen from "./icons/IconMailOpen";
import IconColor from "./icons/IconColor";
import IconColorTimes from "./icons/IconColorTimes";
import IconBulbCheck from "./icons/IconBulbCheck";
import IconUpdate from "./icons/IconUpdate";
import IconCrown from "./icons/IconCrown";
import IconFemale from "./icons/IconFemale";
import IconMale from "./icons/IconMale";
import IconAnimation from "./icons/IconAnimation";
import IconAnimationTimes from "./icons/IconAnimationTimes";
import IconArrowUpLine from "./icons/IconArrowUpLine";
import IconHeartUndo from "./icons/IconHeartUndo";
import IconCarousel from "./icons/IconCarousel";
export var imgIconDefs = {
    "redo": IconRedo,
    "undo": IconUndo,
    "turned off": IconTurnedOff,
    "turned on": IconTurnedOn,
    "percent": IconPercent,
    "monitor": IconMonitor,
    "monitor text": IconMonitorText,
    "monitor hd": IconMonitorHD,
    "monitor sd": IconMonitorSD,
    "monitor 4k": IconMonitor4K,
    "tablet": IconTablet,
    "mobile": IconMobile,
    "mic on": IconMicOn,
    "mic off": IconMicOff,
    "minimize": IconMinimize,
    "carousel": IconCarousel,
    "maximize": IconMaximize,
    "location": IconLocation,
    "mail": IconMail,
    "key": IconKey,
    "help": IconHelpCircle,
    "asking": IconAsking,
    "globe": IconGlobe,
    "heart": IconHeart,
    "heart undo": IconHeartUndo,
    "hashtag": IconHash,
    "flag": IconFlag,
    "flag back": IconFlagBack,
    "folder": IconFolder,
    "folder plus": IconFolderAdd,
    "folder minus": IconFolderMinus,
    "bell": IconBell,
    "link": IconLink,
    "login": IconLogin,
    "logout": IconLogout,
    "logout user": IconUserLogout,
    "link external": IconExternalLink,
    "link internal": IconLinkInternal,
    "clock": IconClock,
    "clipboard": IconClipboard,
    "camera": IconCamera,
    "camera close": IconCameraTimes,
    "chart bar": IconChartBar,
    "chart pie": IconChartPie,
    "tag": IconTag,
    "pencil": IconPencil,
    "exclamation circle": IconExclamationCircle,
    "exclamation triangle": IconExclamationTriangle,
    "award": IconAward,
    "chevron up": IconChevronUp,
    "chevron right": IconChevronRight,
    "chevron down": IconChevronDown,
    "chevron left": IconChevronLeft,
    "chevron left double": IconChevronLeftDouble,
    "chevron right double": IconChevronRightDouble,
    "chevron up double": IconChevronUpDouble,
    "chevron down double": IconChevronDownDouble,
    "chevron left right": IconChevronLeftRight,
    "chevron right left": IconChevronRightLeft,
    "chevron up down": IconChevronUpDown,
    "user": IconUser,
    "users": IconUsers,
    "user minus": IconUserMinus,
    "user plus": IconUserAdd,
    "user times": IconUserTimes,
    "user check": IconUserCheck,
    "admin": IconAdmin,
    "filter": IconFilter,
    "filter times": IconFilterTimes,
    "filter check": IconFilterCheck,
    "filter undo": IconFilterUndo,
    "activities": IconActivities,
    "birthday": IconBirthday,
    "bookmark": IconBookmark,
    "bookmark outline": IconBookmarkOutline,
    "education": IconEducation,
    "chat": IconChat,
    "info brain": IconInfoBrain,
    "cog": IconCog,
    "cog info": IconCogInfo,
    "feed": IconFeed,
    "info": IconInfo,
    "info plus": IconInfoPlus,
    "home": IconHome,
    "star full": IconStarFull,
    "star half": IconStarHalf,
    "star empty": IconStarEmpty,
    "comment": IconComment,
    "playlist": IconPlaylist,
    "playlist edit": IconPlaylistEdit,
    "column full": IconColumn1,
    "column halves": IconColumn2,
    "column thirds": IconColumn3,
    "slideshow": IconSlideshow,
    "friends": IconFriends,
    "add": IconAdd,
    "add circle": IconAddCircle,
    "add square": IconAddSquare,
    "minus": IconMinus,
    "minus circle": IconMinusCircle,
    "minus square": IconMinusSquare,
    "times": IconTimes,
    "times circle": IconTimesCircle,
    "times square": IconTimesSquare,
    "check": IconCheck,
    "check thin": IconCheckThin,
    "check square": IconCheckSquare,
    "check circle": IconCheckCircle,
    "thumb up": IconThumbUp,
    "thumb down": IconThumbDown,
    "search": IconSearch,
    "search close": IconSearchClose,
    "reload": IconReload,
    "trending": IconTrending,
    "more": IconMore,
    "more vertical": IconMoreVertical,
    "edit": IconEdit,
    "copy times": IconCopyTimes,
    "copyright": IconCopyRight,
    "edit close": IconEditClose,
    "empty": IconEmpty,
    "delete": IconDelete,
    "delete empty": IconDeleteEmpty,
    "game": IconGame,
    "games": IconGames,
    "resume": IconResume,
    "stats": IconStats,
    "video player": IconVideoPlayer,
    "audio": IconAudio,
    "image": IconImage,
    "images": IconImages,
    "rocket": IconRocket,
    "shapes": IconShapes,
    "law": IconLaw,
    "dice": IconDice,
    "content aggregation": IconContentAggregation,
    "box": IconBox,
    "save": IconSave,
    "download": IconDownload,
    "download cloud": IconDownloadCloud,
    "upload": IconUpload,
    "upload cloud": IconUploadCloud,
    "upload image": IconUploadImage,
    "upload video": IconUploadVideo,
    "upload audio": IconUploadAudio,
    "copy": IconCopy,
    "send": IconSend,
    "eye open": IconEyeOpen,
    "eye close": IconEyeClose,
    "eye check": IconEyeCheck,
    "eye times": IconEyeTimes,
    "calendar": IconCalendar,
    "unlock": IconUnlock,
    "lock": IconLock,
    "paperclip": IconPaperclip,
    "square": IconColumn1,
    "circle": IconCircle,
    "circle dot": IconCircleDot,
    "quote": IconQuote,
    "excite": IconExcite,
    "smiley smile": IconEmoSmile,
    "smiley frown": IconEmoFrown,
    "smiley neutral": IconEmoNeutral,
    "bulb": IconBulb,
    "bulb check": IconBulbCheck,
    "rotate left": IconRotateLeft,
    "rotate right": IconRotateRight,
    "rotate up": IconRotateUp,
    "rotate down": IconRotateDown,
    "table": IconTable,
    "zoom in": IconZoomIn,
    "zoom out": IconZoomOut,
    "grid vertical": IconGridV,
    "grid horizontal": IconGridH,
    "mirror vertical": IconMirrorV,
    "mirror horizontal": IconMirrorH,
    "image effects": IconImageEffects,
    "book": IconBook,
    "article check": IconArticleCheck,
    "article times": IconArticleTimes,
    "edit table top": IconEditTableTop,
    "edit table bottom": IconEditTableBottom,
    "edit table left": IconEditTableLeft,
    "edit table right": IconEditTableRight,
    "merge": IconMerge,
    "unmerge": IconUnmerge,
    "check times": IconCheckTimes,
    "add above": IconAddAbove,
    "add right": IconAddRight,
    "add below": IconAddBelow,
    "add left": IconAddLeft,
    "delete row": IconDeleteRow,
    "delete column": IconDeleteColumn,
    "crop": IconCrop,
    "expand": IconExpand,
    "decrease": IconDecrease,
    "package": IconPackage,
    "bomb": IconBomb,
    "language": IconLanguage,
    "hotspot": IconHotspot,
    "questionark": IconQuestionmark,
    "questionark circle": IconQuestionmarkCircle,
    "wiki": IconWiki,
    "sort az": IconSortAZ,
    "sort za": IconSortZA,
    "graph node": IconGraphNode,
    "graph edge": IconGraphEdge,
    "branch top right": IconBranchTopRight,
    "play": IconPlay,
    "pause circle": IconPauseCircle,
    "pause": IconPause,
    "play circle": IconPlayCircle,
    "music": IconMusic,
    "file": IconFile,
    "editor text color": IconEditorTextColor,
    "editor text background": IconEditorTextBackground,
    "editor text bold": IconEditorTextBold,
    "editor text italic": IconEditorTextItalic,
    "editor text underline": IconEditorUnderline,
    "editor list bullet times": IconEditorListBulletTimes,
    "editor list bullet": IconEditorListBullet,
    "editor list ordered": IconEditorListOrdered,
    "editor text size": IconEditorTextSize,
    "editor ppe link": IconEditorPPElink,
    "vote up": IconUpVote,
    "vote down": IconDownVote,
    "at sign": IconAtSign,
    "history back": IconHistoryBack,
    "history forward": IconHistoryForward,
    "version": IconVersion,
    "subtitle": IconSubtitle,
    "thumbnail": IconThumbnail,
    "workflow": IconWorkflow,
    "select": IconSelect,
    "select all": IconSelectAll,
    "menu": IconMenu,
    "menu close": IconMenuClose,
    "reply": IconReply,
    "forward": IconForward,
    "publish": IconPublish,
    "unpublish": IconUnpublish,
    "published": IconPublished,
    "unpublished": IconUnpublished,
    "data privacy": IconDataPrivacy,
    "file reference": IconFileReference,
    "video reference": IconVideoReference,
    "copy video": IconCopyVideo,
    "language select": IconLanguageSelect,
    "language square": IconLanguageSquare,
    "user edit": IconUserEdit,
    "checkbox checked": IconCheckboxChecked,
    "checkbox unchecked": IconCheckboxUnchecked,
    "cms search": IconCmsSerach,
    "cms admin": IconCmsAdmin,
    "table add row": IconTableAddRow,
    "table minus row": IconTableMinusRow,
    "tableview": IconTableview,
    "grid": IconGrid,
    "arrow up": IconArrowUp,
    "arrow up line": IconArrowUpLine,
    "arrow right": IconArrowRight,
    "arrow down": IconArrowDown,
    "arrow left": IconArrowLeft,
    "folder open": IconFolderOpen,
    "folder up": IconFolderUp,
    "copy mode": IconCopyMode,
    "more close": IconMoreClose,
    "qr code": IconQrCode,
    "qr code times": IconQrCodeTimes,
    "archive": IconArchive,
    "asterisk": IconAsterisk,
    "stop": IconStop,
    "fast forward": IconFastForward,
    "fast backward": IconFastBackward,
    "skip forward": IconSkipForward,
    "skip backward": IconSkipBackward,
    "exclamation": IconExclamation,
    "column plus": IconColumnPlus,
    "column minus": IconColumnMinus,
    "import": IconImport,
    "export": IconExport,
    "arrow up down": IconArrowUpDown,
    "arrow left right": IconArrowLeftRight,
    "feed rss": IconFeedRss,
    "folder empty": IconFolderEmpty,
    "position top left": IconPosTL,
    "position top center": IconPosTC,
    "position top right": IconPosTR,
    "position center left": IconPosCL,
    "position center center": IconPosCC,
    "position center right": IconPosCR,
    "position bottom left": IconPosBL,
    "position bottom center": IconPosBC,
    "position bottom right": IconPosBR,
    "mail open": IconMailOpen,
    "color": IconColor,
    "color times": IconColorTimes,
    "update": IconUpdate,
    "crown": IconCrown,
    "female": IconFemale,
    "male": IconMale,
    "animation": IconAnimation,
    "animation times": IconAnimationTimes,
};
var FillColor = styled.span(function (p) { return "\n    svg{\n        fill: ".concat(getColor(p, p.filledWithColor), ";\n    }\n"); });
var Icon = React.memo(function (props) {
    var _a, _b;
    var name = props.name, p = __rest(props, ["name"]);
    var I = (_a = imgIconDefs[name]) !== null && _a !== void 0 ? _a : imgIconDefs["empty"];
    return React.createElement(FillColor, { filledWithColor: (_b = props.filledWithColor) !== null && _b !== void 0 ? _b : "none" },
        React.createElement(I, __assign({}, p)));
});
export default Icon;
//# sourceMappingURL=Icon.js.map